import React, { useState, useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import styled from "styled-components";
import { updateAppoinment, updateAppoinmentStatus } from "../../api/apiHandler";
import Swal from "sweetalert2";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { useMeetingManager } from "amazon-chime-sdk-component-library-react";
export function RejoinPopup({
  rejoin,
  setRejoin,
  handleJoinMeeting,
  meetindData,
}) {
  const { interimTranscript, resetTranscript, transcript, listening } =
    useSpeechRecognition();
  console.log(meetindData, "meetindData45d4q236");

  const meetingManager = useMeetingManager();
  const handleMeetingStatus = async () => {
    const updateStatusObj = {
      appointment_id: meetindData?.meeting_information?.[0]?.appointment_id,
      appointment_status: process.env.REACT_APP_MEETING_DONE,
    };
    const role = meetindData?.meeting_information?.[0]?.role;
    // If role is 1, remove appointment_status
    if (role == 1) {
      delete updateStatusObj.appointment_status;
    }

    try {
      let response;

      if (role == 2 || role == 4) {
        response = await updateAppoinmentStatus(updateStatusObj);
      } else {
        response = await updateAppoinment(updateStatusObj);
      }

      response = JSON.parse(response);

      if (response.code == process.env.REACT_APP_SUCCESS) {
        await meetingManager.leave();
        SpeechRecognition.stopListening();
        setRejoin(!rejoin);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (error) {
      console.error("Meeting status update failed:", error);
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: "Unable to update the meeting status.",
      });
    }
  };

  const handleRejoin = () => {
    Swal.fire({
      icon: "warning",
      title: "Exit Meeting",
      text: "Are you sure you want to exit the meeting?",
      showCancelButton: true,
      confirmButtonText: "Yes, Exit",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleMeetingStatus();
      } else {
      }
    });
    console.log(meetindData, "meetindData123213");
    localStorage.removeItem("meeting_room");
  };

  return (
    <>
      <ModalCstm size="sm" centered show={rejoin}>
        <Modal.Body className="position-relative p-2">
          {/* Top-Left Minus Button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setRejoin(!rejoin);
            }}
            className="position-absolute border-0 bg-transparent"
            style={{ top: 10, left: 15 }}
            aria-label="Minimize"
          >
            {/* Inline SVG minus icon */}
            <svg
              width="20"
              height="20"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="256" cy="256" r="256" fill="#0078D7" />
              <rect x="128" y="240" width="256" height="32" fill="#FFFFFF" />
            </svg>
          </button>

          {/* Top-Right Close Button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleRejoin();
            }}
            className="position-absolute border-0 bg-transparent"
            style={{ top: 10, right: 10 }}
            aria-label="Close"
          >
            {closeIcn}
          </button>

          {/* Main Content */}
          <div
            className="text-center py-0 px-1 cursor-pointer"
            onClick={() => handleJoinMeeting(meetindData)}
          >
            <h4 className="m-0 themeClr fw-bold text-uppercase">
              Ongoing Meeting
            </h4>
            <h3 className="m-0 fw-normal text-black ">
              {parseInt(localStorage.getItem("user_login_type_role")) === 2
                ? `Dr. ${localStorage.getItem("user_name")}`
                : parseInt(localStorage.getItem("user_login_type_role")) === 4
                ? `Pr. ${localStorage.getItem("user_name")}`
                : `Mr. ${localStorage.getItem("user_name")}`}
            </h3>
            <h2 className="m-0 mt-1 themeClr fw-bold text-decoration-underline">
              JOIN
            </h2>
            <h3 className="m-0 fw-normal text-black mt-2">
              {parseInt(localStorage.getItem("user_login_type_role")) !== 2 &&
              parseInt(localStorage.getItem("user_login_type_role")) !== 4
                ? `Dr. ${meetindData?.doctor_information?.doctor_full_name}`
                : `Mr. ${meetindData?.patient_information?.patient_full_name}`}
            </h3>
          </div>

          {/* Bottom-Right Exit Button */}
          <div className="d-flex justify-content-center">
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleRejoin();
              }}
              className=" commonBtn btn bg-danger-light "
              // style={{ bottom: 10, right: 10 }}
              aria-label="Exit"
            >
              Exit {exitIcon}
            </button>
          </div>
        </Modal.Body>
      </ModalCstm>
    </>
  );
}

const ModalCstm = styled(Modal)`
  .modal-sm {
    max-width: 230px;
    margin: 0 auto;
    .modal-content {
      border: 2px solid #3add30;
      border-radius: 30px;
    }
  }
`;

// export default RejoinPopup
const exitIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 10V8H7V6H12V4L15 7L12 10ZM11 9V13H6V16L0 13V0H11V5H10V1H2L6 3V12H10V9H11Z"
      fill="#D33E3E"
    />
  </svg>
);
const minusIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="256" cy="256" r="256" fill="#0078D7" />
    <rect x="128" y="240" width="256" height="32" fill="#FFFFFF" />
  </svg>
);
const closeIcn = (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_2)">
      <mask
        id="mask0_1_2"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="22"
        height="22"
      >
        <path
          d="M9.94527 24.0874C13.8595 27.9836 20.1911 27.969 24.0874 24.0547C27.9836 20.1405 27.969 13.8089 24.0548 9.91265C20.1405 6.01642 13.8089 6.03102 9.91266 9.94526C6.01644 13.8595 6.03104 20.1911 9.94527 24.0874Z"
          fill="white"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.296 13.8058L20.1697 11.6894L16.9951 14.8787L13.8058 11.7041L11.6894 13.8303L14.8787 17.0049L11.7041 20.1942L13.8303 22.3106L17.0049 19.1213L20.1942 22.2959L22.3106 20.1697L19.1213 16.9951L22.296 13.8058Z"
          fill="black"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1_2)">
        <path
          d="M16.9609 0.0294824L33.9705 16.9609L17.0391 33.9705L0.0294914 17.0391L16.9609 0.0294824Z"
          fill="#216fc8"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_2">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(16.9609 0.0294824) rotate(44.8679)"
        />
      </clipPath>
    </defs>
  </svg>
);
